export class Constants {
    public static orders = {
        order: 'order',
        parcelOrders: 'parcel-orders',
        gridColumnsTitle: {
            orderNumber: 'Order Number',
            trackingID: 'Tracking ID',
            parentRetailerName: 'Parent Retailer Name',
            retailerName: 'Retailer Name',
            service: 'Service',
            originCountry: 'Origin Country',
            destinationCountry: 'Destination Country',
            latestEvent: 'Latest Event',
            latestEventDateTime: 'Latest Event Date-Time',
            processedDate: 'Processed Date',
            deliveryDate: 'Delivery Date',
            status: 'Status',
            delay: 'Delay',
            delayedBy: 'Delayed By',
            reason: 'Reason',
            category: 'Category',
            notifiedBy: 'Notified By',
            comment: 'Comment',
            parcelCode: 'Parcel Code',
            postcode: 'Postal Code'
        },
        navTabs: {
            all: 'All',
            onTime: 'Parcels In Transit',
            delay: 'Delay',
            delivered: 'Parcels Completed'
        }
    };

    public static excelFileType = {
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xls: 'application/vnd.ms-excel',
        csv: 'text/csv'
    };

    public static errorMessages = {
        excelUpload: 'Please upload only excel file!!!'
    };

    public static inboundGraph = {
        totalCount: 'total'
    };

    public static keys = {
        keyProductUpdate: 'key=product_update',
        keyBrand: 'key=brand'
    };
}

export enum ErrorCode {
    UploadError = 608
}

export enum RedirectToUrl {
    ShippingMethodSync = 'integration/service-mapping/unmapped',
    Order_ProductSync = 'integration/marketplaces/all'
}

export enum ModuleNames {
    ProductsConfiguration = 'Products',
    Products = 'Inventory',
    Orders = 'Orders',
    Suppliers = 'Suppliers',
    Reports = 'Reports',
    Integrations = 'Integrations',
    PurchaseOrders = 'PO',
    Inbound = 'Inbound',
    
}

export enum ConnectShippingTypes {
    EPAQStandard = 'e-PAQ Standard', // 4
    EPAQStandardCaps = 'E-PAQ Standard', // 4
    EPAQStandardID = 4,
    B2CEPAQStandard = 'B2C E-PAQ Standard',
    B2BEPAQStandard = 'B2B E-PAQ Standard',
    
    EPAQSelect = 'e-PAQ Select', // 5
    EPAQSelectCaps = 'E-PAQ Select', // 5
    EPAQSelectID = 5,
    B2CEPAQSelect = 'B2C E-PAQ Select',
    B2BEPAQSelect = 'B2B E-PAQ Select',

    EPAQPlus = 'e-PAQ Plus', // 6
    EPAQPlusCaps = 'E-PAQ Plus', // 6
    EPAQPlusID = 6,
    B2CEPAQPlus = 'B2C E-PAQ Plus',
    B2BEPAQPlus = 'B2B E-PAQ Plus',

    EPAQElite = 'e-PAQ Elite', // 7
    EPAQEliteCaps = 'E-PAQ Elite', // 7
    EPAQEliteID = 7,
    B2CEPAQElite = 'B2C E-PAQ Elite',
    B2BEPAQElite = 'B2B E-PAQ Elite',

    STANDARD_DELIVERY = 'standard_delivery'
}


export enum KitType {
    Offline = 2,
    Online = 1
}